import './Model1.css'
import G from '../Assets/gp.jpeg';
import M from '../Assets/m2.png';
import N from '../Assets/n3.png';
import  GitHub  from '@mui/icons-material/GitHub';

export default function Model1() {
  return (
    <div id='model1'>
      <div className='founderFathers'>
      <h1 className='model-title'>Founder Fathers</h1>
      </div>
        <div className="divider"></div>
        <div className="members">
          <div className="member">
            <img width={400} height={400} src={G}/>
            <div className="description">
                <h1>George Meshveliani</h1>
                <h2>CEO</h2>
                {/* <p>
                Consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet consectet.
                </p> */}
                <a href='https://github.com/George1Meshveliani' target="_blank">
                <div className="social-media">
                  <GitHub />
                </div>
                </a>
            </div>
          </div>
          <div className="member">
            <img width={400} src={M}/>
            <div className="description">
                <h1>Mikheil Papunidze</h1>
                <h2>CTO</h2>
                {/* <p>
                Consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet consectet.
                </p> */}
                <a href='https://github.com/MikheilPapundze' target="_blank">
                <div className="social-media">
                  <GitHub />
                </div>
                </a>

            </div>
          </div>
          <div className="member">
            <img width={400} src={N}/>
            <div className="description">
                <h1>Nika Dumbadze</h1>
                <h2>CCO</h2>
                {/* <p>
                Consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet consectet.
                </p> */}
                <a href="https://github.com/NikaDumbo" target="_blank">
                <div className="social-media">
                  <GitHub />
                </div>
                </a>
            </div>
          </div>
        </div>
    </div>
  );
}
